import React from 'react';
import {useIntl} from 'react-intl';
import {FlexContainer, Heading, TextField, Link as LinkComponent, FlexRow, FlexColumn, Text} from '@forecast-it/design-system';

import Logo, {LOGO_SIZE} from '../../forecast-app/shared/components/logo/Logo';
import {Content, Page, PageContent, WideButton} from './Sage.styled';
import {Link as RouterLink} from 'react-router-dom';

export type SageForgotPasswordProps = {
	errorMessage?: string;
	email?: string;
	onEmailChange: (value: string) => void;
	onReset: () => void;
	isSent: boolean;
};

export const SageForgotPassword = ({
	errorMessage,
	email,
	onEmailChange,
	onReset,
	isSent,
}: SageForgotPasswordProps): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<Page>
			<Content alignItems="center" justifyContent="center">
				<Logo size={LOGO_SIZE.MEDIUM} />
				<FlexContainer>
					<PageContent gap="xl">
						{isSent ? (
							<>
								<FlexColumn gap="l">
									<Heading size="3">{formatMessage({id: 'login.forgot_password.check_your_email'})}</Heading>
									<Text>
										{formatMessage(
											{
												id: 'login.forgot_password.instructions',
											},
											{b: b => <b>{b}</b>, email: email, br: <br />}
										)}
									</Text>
								</FlexColumn>
							</>
						) : (
							<>
								<FlexColumn gap="l">
									<Heading size="3">
										{formatMessage({id: 'login.forgot_password.reset_your_password'})}
									</Heading>

									<TextField
										label={formatMessage({id: 'common.email'})}
										autoComplete="email"
										errorText={errorMessage}
										value={email}
										onValueChange={onEmailChange}
									/>
								</FlexColumn>
								<WideButton onPress={onReset}>{formatMessage({id: 'login.reset-password'})}</WideButton>
							</>
						)}
						<FlexRow alignItems="center" justifyContent="center">
							<RouterLink to="/" component={LinkComponent}>
								{formatMessage({id: 'login.forgot_password.return_to_sign_in'})}
							</RouterLink>
						</FlexRow>
					</PageContent>
				</FlexContainer>
			</Content>
		</Page>
	);
};
